module.exports = "query Banners (\n  $page: Int = 1,\n  $limit: Int = 10,\n  $asc: String,\n  $desc: String,\n  $statusAdmin: String,\n  $type: String,\n  $name: String,\n) {\n  banners (page: $page, limit: $limit, asc: $asc, desc: $desc, statusAdmin: $statusAdmin, type: $type, name: $name) {\n    data {\n      id\n      name\n      partner {\n        id\n        name\n      }\n      end_date\n      status\n      type\n      name\n      image\n      image_secondary\n    }\n    current_page\n    from\n    to\n    per_page\n    total\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/graphQL/queries/Banners.graphql
// module id = sIG8
// module chunks = 1624